import { useEffect } from 'react'

import { DEFAULT_FONT } from './useEditorBaseFont.constants'
import { applyBaseFont } from './useEditorBaseFont.utils'

export function useEditorBaseFont({ editorInitiated, editorRef, font }) {
  const defaultFont = font ?? DEFAULT_FONT

  useEffect(() => {
    const editor = editorRef.current

    function addBaseFont() {
      applyBaseFont(editor, defaultFont)
    }

    if (editor) {
      addBaseFont()

      editor.off('LoadContent', addBaseFont)
      editor.off('SetContent', addBaseFont)
      editor.on('LoadContent', addBaseFont)
      editor.on('SetContent', addBaseFont)
    }

    return () => {
      editor?.off('LoadContent', addBaseFont)
      editor?.off('SetContent', addBaseFont)
    }
  }, [defaultFont, editorInitiated])

  return { defaultFont }
}
